module.exports = __webpack_public_path__ + "img/banner-3-ko.3026dbaf.png";